import { rem } from 'polished';
import Icon from '../../Icon';
import React from 'react';
import StatusBar from '../StatusBar';
import styled, { css, useTheme } from 'styled-components';
const COURIER_MESSAGES_URL = 'https://my.sportnet.online/messages';
const NotificationBell = styled(Icon) `
  position: relative;
  ${({ notificationCount }) => notificationCount > 0 &&
    css `
      &::after {
        content: '${notificationCount >= 100 ? '99+' : notificationCount}';
        position: absolute;
        border-radius: 50%;
        background-color: rgba(255, 42, 100, 1);
        border: 2px solid white;
        color: white;
        font-size: ${rem(9)};
        font-weight: 500;
        height: ${rem(18)};
        width: ${rem(18)};
        display: flex;
        align-items: center;
        justify-content: center;
        top: ${rem(-11)};
        right: ${rem(-8)};
      }
    `}
`;
const StatusBarNotifications = ({ notificationCount }) => {
    const theme = useTheme();
    return (React.createElement(StatusBar.Button, { onClick: () => window.open(COURIER_MESSAGES_URL) },
        React.createElement(NotificationBell, { size: "l", color: theme.color.primary, name: "notification", notificationCount: notificationCount })));
};
export default React.memo(StatusBarNotifications);
